module.exports = require("@splunk/visualization-context/ImageRegistry");